import { render, staticRenderFns } from "./wf-parallel-radio-buttons-edit.vue?vue&type=template&id=79ba0466&scoped=true&"
import script from "./wf-parallel-radio-buttons-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-parallel-radio-buttons-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-parallel-radio-buttons-edit.vue?vue&type=style&index=0&id=79ba0466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ba0466",
  null
  
)

export default component.exports